import React, { useState } from 'react';

export function Settings() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const [selectedUrl, setSelectedUrl] = useState('http://localhost:3002/productsRPL');

  const possibleUrls = [
    'http://localhost:3002/productsRPL',
    'http://localhost:3002/api/productsRPL',
    'http://localhost:3002/medprax/productsRPL',
    'http://localhost:3000/productsRPL',
    'http://localhost:3000/api/productsRPL'
  ];

  const testProductsRPL = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await fetch(selectedUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          planSubOptionCode: '44M',
          productCode: '1005667001'
        })
      });

      // Get the response as text first to see what we're actually getting
      const responseText = await response.text();
      
      // Check if response is HTML (error page)
      if (responseText.startsWith('<!DOCTYPE') || responseText.startsWith('<html')) {
        setError(`Server returned HTML instead of JSON. Status: ${response.status}. This usually means:
        1. Server isn't running
        2. Wrong URL/port
        3. Route doesn't exist
        
        Response preview: ${responseText.substring(0, 200)}...`);
        return;
      }

      // Try to parse as JSON
      const data = JSON.parse(responseText);

      if (response.ok) {
        setResult(data);
      } else {
        setError(data.error || `HTTP Error: ${response.status} - ${response.statusText}`);
      }
    } catch (err) {
      setError(`Network Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Test Products RPL Route</h1>
      
      <div className="bg-gray-50 p-4 rounded-lg mb-6">
        <h2 className="text-lg font-semibold mb-2">Test Parameters:</h2>
        <p><strong>Plan Sub Option Code:</strong> 44M</p>
        <p><strong>Nappi Code:</strong> 1005667001</p>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium mb-2">Test URL:</label>
        <select 
          value={selectedUrl} 
          onChange={(e) => setSelectedUrl(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-lg"
        >
          {possibleUrls.map(url => (
            <option key={url} value={url}>{url}</option>
          ))}
        </select>
        <p className="text-sm text-gray-600 mt-1">Try different URL combinations to find the correct endpoint</p>
      </div>

      <button
        onClick={testProductsRPL}
        disabled={loading}
        className={`px-6 py-3 rounded-lg font-medium transition-colors ${
          loading
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
        }`}
      >
        {loading ? 'Testing...' : 'Test Products RPL Route'}
      </button>

      {error && (
        <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <h3 className="text-lg font-semibold text-red-800 mb-2">Error:</h3>
          <p className="text-red-700">{error}</p>
        </div>
      )}

      {result && (
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <h3 className="text-lg font-semibold text-green-800 mb-2">Success! Response:</h3>
          <pre className="bg-white p-3 rounded border text-sm overflow-auto max-h-96">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}